import React from 'react';
import PropTypes from 'prop-types';

import Colours from '../definitions/Colours';


function MenuIcon({ stroke, fill, ...otherProps }) {
    return (
        <svg 
            viewBox="0 0 32 32"
            shapeRendering="crispEdges"
            stroke={stroke}
            fill={fill}
            {...otherProps}
        >
            <path d="M2.5 11.5h27M2.5 21.5h27" />
        </svg>
    );
}

MenuIcon.propTypes = {
    stroke: PropTypes.oneOf(
        Object.values(Colours),
    ),
    fill: PropTypes.oneOf(
        Object.values(Colours),
    ),
};

MenuIcon.defaultProps = {
    stroke: Colours.BLACKBERRY,
    fill: undefined,
};

export default MenuIcon;